import React from 'react';
import { getCalendarBlockerEventDetail } from 'api/google'
import { Event, TServerCalendarBlockerEventDetail } from 'types/calendar';


const useCalendarBlockerEventDetail = (event?: Event): [TServerCalendarBlockerEventDetail | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TServerCalendarBlockerEventDetail>();
    const fetchData = async () => {
        if (loading || !event) return;
        try {
            setLoading(true);
            const result = await getCalendarBlockerEventDetail(event.id + '');
            if (!result.error) {
                const resData = result?.data?.data || [];
                setData(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        if (event) {
            setData(undefined);
            fetchData();
        }
    }, [event]);

    return [data, loading, fetchData];
};

export default useCalendarBlockerEventDetail;
